import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz';

class DateTimeConverter {
    public zonedToUtc(date: string, time: string, timezone: string): string {
        const dateObj = zonedTimeToUtc(`${date}T${time}`, timezone);
        return dateObj.toISOString();
    }

    public utcToZoned(datetime: string, timezone: string): { date: string; time: string } {
        const date = formatInTimeZone(datetime, timezone, 'yyyy-MM-dd');
        const time = formatInTimeZone(datetime, timezone, 'HH:mm:ss');
        return { date, time };
    }
}

const dateTimeConverter = new DateTimeConverter();

export default dateTimeConverter;
